import classNames from "classnames";
import React from "react";

export interface DoorIconProps {
  isActive?: string;
}

export const DeKaap: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.273 2H2v25.273h23.273V2Zm2 25.273V60H0V0h27.273v27.273ZM2 27.954v8.864h23.273v-8.863H2ZM25.273 58V37.5H2V58h23.273Z"
        fill="#292747"
      />
    </svg>
  );
};
